
import $ from 'jquery';
import _forEach from 'lodash/forEach';
import _isNaN from 'lodash/isNaN';
import { SELECTORS } from '../constants/selectors';
import TestController from './TestController';
import UiController from '../ui/UiController';

/**
 * @property UI_FEEDBACK_DIALOG_TEMPLATE
 * @type {string}
 * @final
 */
const UI_FEEDBACK_DIALOG_TEMPLATE = `
    <div class="option-dialog dialog">
        <p class="dialog-title">Feedback after test</p>
        <div class="dialog-body nice-scrollbar">
            <textarea class="dialog-body-textarea" placeholder="Enter your feedback here" style="width: 99%; height: 400px; padding: 0; resize: none;"></textarea>
        </div>
    </div>`;

/**
 * @property UI_FEEDBACK_CLOSE_DIALOG_BUTTON
 * @type {string}
 * @final
 */
const UI_FEEDBACK_CLOSE_DIALOG_BUTTON = `
    <button class="dialog-body-download-button" style="margin-right: 5px;">Close</button>`;

/**
 * @property UI_FEEDBACK_DOWNLOAD_BUTTON
 * @type {string}
 * @final
 */
const UI_FEEDBACK_DOWNLOAD_AND_SUBMIT_BUTTON = `
    <button class="dialog-body-download-button" style="margin-left: 5px;">Submit and download Test Log</button>`;

/**
 * @property UI_FEEDBACK_BUTTONS_CONTAINER
 * @type {string}
 * @final
 */
const UI_FEEDBACK_BUTTONS_CONTAINER = `
    <div class="dialog-body-button-container"></div>
`;


export default class TesetFeedbackUiController {
    
    constructor($element){

        /**
         * Root DOM element
         *
         * @property $element
         * @type {jquery|HTML Element}
         * @default $element
         */
        this.$element = $element;

        /**
         * Dialog DOM element
         *
         * @property $dialog
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialog = null;

        /**
         * Dialog's body DOM element
         *
         * @property $dialogBody
         * @type {jquery|HTML Element}
         * @default null
         */
        this.$dialogBody = null;

        this.init();
    }

    /**
     * Initializes the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method init
     * @private
     * @chainable
     */
    init(){
        this._buildDialog();

        return this;
    }

    /**
     * Builds the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method _buildDialog
     * @private
     */
    _buildDialog() {
        this.$dialog = $(UI_FEEDBACK_DIALOG_TEMPLATE);
        this.$dialogBody = this.$dialog.find(SELECTORS.DOM_SELECTORS.DIALOG_BODY);

        const $closeButton = $(UI_FEEDBACK_CLOSE_DIALOG_BUTTON);
        $closeButton.on('click', () => {
            this.toggleDialog();
        });

        const $downloadButton = $(UI_FEEDBACK_DOWNLOAD_AND_SUBMIT_BUTTON);
        $downloadButton.on('click', () => {
            const feedback = this.$dialogBody.find('textarea').val();
            if (!feedback) {
                UiController.ui_log('Feedback cannot be empty', true);
                return;
            }
            this.$dialogBody.find('textarea').val('');
            TestController.submitFeedback(feedback);
            TestController.downloadTestLog();
            console.log(feedback);
            console.log('Test Log downloaded');

            this.toggleDialog();
        });

        const $buttonContainer = $(UI_FEEDBACK_BUTTONS_CONTAINER);
        $buttonContainer.append($closeButton);
        $buttonContainer.append($downloadButton);

        this.$dialog.append($buttonContainer);

        this.$element.append(this.$dialog);
    }

    /**
     * Returns whether the testing dialog is open
     *
     * @for TesetFeedbackUiController
     * @method isDialogOpen
     * @return {boolean}
     */
    isDialogOpen() {
        return this.$dialog.hasClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * Toggles the testing dialog
     * 
     * @for TesetFeedbackUiController
     * @method toggleDialog
     */
    toggleDialog() {
        this.$dialog.toggleClass(SELECTORS.CLASSNAMES.OPEN);
    }

}